/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var timeout;
export var debounce = function (func, wait) {
    if (wait === void 0) { wait = 500; }
    return function (data) {
        clearTimeout(timeout);
        timeout = window.setTimeout(function () { return func(data); }, wait);
    };
};
//# sourceMappingURL=debounce.js.map